module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "owl-carousel"
  }, [_vm._l((_vm.items), function(item, i) {
    return [(item.banner) ? _c('a', {
      staticClass: "item banner",
      style: (("background-image: url(" + (item.img) + ")")),
      attrs: {
        "href": item.href
      }
    }, [_c('p', {
      staticClass: "infoSlider"
    }, [_vm._v(_vm._s(i + 1) + " из " + _vm._s(_vm.items.length))])]) : _c('div', {
      staticClass: "item",
      style: (("background-image: url(" + (item.img) + ")"))
    }, [_c('div', {
      staticClass: "flexContainer"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "cols s_24 m_16 l_13"
    }, [_c('div', {
      staticClass: "topBlock"
    }, [(item.title) ? _c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (item.text) ? _c('p', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "cols s_24"
    }, [_c('div', {
      staticClass: "flexBlock"
    }, [(item.popup) ? [(item.button) ? _c('a', {
      staticClass: "yam-button  waves-effect waves-light",
      attrs: {
        "data-key": item.button_key,
        "href": item.popup,
        "data-fancybox": ""
      }
    }, [_vm._v(_vm._s(item.button))]) : _vm._e()] : [(item.button) ? _c('a', {
      staticClass: "yam-button  waves-effect waves-light",
      attrs: {
        "href": item.href
      }
    }, [_vm._v(_vm._s(item.button))]) : _vm._e()], _vm._v(" "), _c('p', {
      staticClass: "infoSlider"
    }, [_vm._v(_vm._s(i + 1) + " из " + _vm._s(_vm.items.length))])], 2)])])])])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2e6ab15a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/mainSlider.vue
// module id = 315
// module chunks = 22